module.exports = __webpack_public_path__ + "img/video-thumb-1.a94b9be7.jpg";